import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

export interface PdfPreviewContext {
  source: string;
  sourceShort: string;
  sourceLabel: string;
  title: string;
  author: string;
  date: string;
  pageCount: number;
  asset: string;
  page: number;
  excerpt: string;
}

@Component({
  selector: 'app-exp-pdf-preview-drawer',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './pdf-preview-drawer.component.html',
})
export class PdfPreviewDrawerComponent {
  @Input() open = false;
  @Input() context: PdfPreviewContext | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() download = new EventEmitter<void>();

  get sectionIndex(): number {
    if (!this.context) return 1;
    return Math.max(1, this.context.page - 4);
  }

  get sectionLabel(): string {
    if (!this.context) return 'Investment case';
    return this.context.asset === 'GOLD' ? 'Portfolio hedges' : 'Investment case';
  }

  get sourceLabelUpper(): string {
    return (this.context?.sourceLabel || '').toUpperCase();
  }

  get sourceShortUpper(): string {
    return (this.context?.sourceShort || '').toUpperCase();
  }

  formatDate(iso: string): string {
    if (!iso) return '';
    const d = new Date(iso);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  onBackdropClick(): void {
    this.close.emit();
  }

  onCloseClick(): void {
    this.close.emit();
  }

  onDownloadClick(): void {
    this.download.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open) this.close.emit();
  }
}
